import _ from "lodash";
// eslint-disable-next-line no-restricted-imports
import { css } from "styled-components";
import "styled-components/macro";
import { useGridBorderRadius } from "./use-grid-border-radius"; // DO NOT REMOVE. Necessary for using the css={`...`} prop
import { Colors } from "@blueprintjs/core";

export function useExtraGridCss(columnDefs) {
  const brad = useGridBorderRadius();

  if (!_.size(columnDefs)) {
    return undefined;
  }

  const numericalCellSelector = columnDefs
    .filter(col =>
      ["floatColumn", "integerColumn", "moneyColumn"].includes(col.type)
    )
    .map(col => col.field)
    .map(colId => `&[col-id="${colId}"]`)
    .join(", ");

  return css`
    overflow: hidden;
    border-radius: 0 0 ${brad} ${brad};

    & .ag-row-odd {
      background-color: #30404d;
      &.ag-row-hover {
        background-color: ${Colors.DARK_GRAY5};
      }
    }

    & .ag-row-even {
      background-color: #293742;
      &.ag-row-hover {
        background-color: ${Colors.DARK_GRAY5};
      }
    }

    & .ag-cell[role="gridcell"] {
      ${numericalCellSelector} {
        text-align: right;
      }
    }

    & .ag-filter-apply-panel > button {
      background-color: rgb(37, 43, 46);
    }
  `;
}

// const BIG_HEADER_CELLS = css`
//   & .ag-header-cell-label .ag-header-cell-text {
//     white-space: normal !important;
//   }
//
//   & .ag-header-cell::after {
//     top: unset !important;
//     height: 60% !important;
//     margin-top: unset !important;
//   }
// `;

export const CSS_TO_ALWAYS_SHOW_SCROLLBARS = `
  .ag-grid-body-viewport {
    overflow: scroll !important;
  }
  
  && ::-webkit-scrollbar {
    -webkit-appearance: none !important;
    width: 8px !important;
    height: 8px !important;
  }

  && ::-webkit-scrollbar-track {
    //-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1) !important;
  }

  && ::-webkit-scrollbar-thumb {
    -webkit-appearance: none !important;
    border-radius: 4px !important;
    background-color: rgba(255, 255, 255, 0.7) !important;
    box-shadow: 0 0 -3px 0 rgba(255, 255, 255, 0.5) !important;
  }
`;
